import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedAdditionalServiceKilometricPrice: {
      priceBreakdowns: [],
      line: {},
      additionalServiceDistanceBasedPricings: [],
    },
  }),

  mutations: {
    setSelectedAdditionalServiceKilometricPrice(state, kilometricPrice) {
      Vue.set(state, "selectedKilometricPrice", kilometricPrice);
    },
  },

  actions: {
    //TODO: load, update, create
    createAdditionalServiceKilometricPrice: (context, request) => {
      return axios
        .post(
          context.getters.getMcServiceUrl +
            "/additional-service-pricing-periods/get-additional-service-distance-based-pricing-by-orer/" +
            request.selectedOrerId,
          request.additionalServiceDistanceBasedPricingRules,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createAdditionalServicePricingPeriods: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadAdditionalServicePricingPeriods: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/entity").then((response) => {
        return response.data;
      });
    },

    loadAdditionalServicePricingPeriod: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    sendToApprovalAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/sendToApproval/" + distanceBasedPrice.intentId)
        .then((response) => {
          if (distanceBasedPrice.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
            distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
          } else if (distanceBasedPrice.intents[0].type === "'CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
            distanceBasedPrice.intents[0].status = "WAITING_APPROVAL";
          }
          return response.data;
        });
    },

    recallAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/recall/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        helper.recallOrRejectEntity(distanceBasedPrice, "ADDITIONAL_SERVICE_PRICING_PERIOD");
        return response.data;
      });
    },

    cancelAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/cancel/" + distanceBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        return response.data;
      });
    },

    rejectAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/reject/" + distanceBasedPrice.intentId).then((response) => {
        if (distanceBasedPrice.intents[0].type === "DELETE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents = null;
          distanceBasedPrice.intentId = 0;
        } else if (distanceBasedPrice.intents[0].type === "CREATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        } else if (distanceBasedPrice.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_PRICING_PERIOD") {
          distanceBasedPrice.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    publishAdditionalServicePricingPeriod: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    deleteAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/entity/" + distanceBasedPrice.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          distanceBasedPrice.intents = intents;
          distanceBasedPrice.intentId = response.data.id;
          return distanceBasedPrice;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAdditionalServicePricingPeriod: (context, distanceBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/draft/" + distanceBasedPrice.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    loadSelectedHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-pricing-periods/history/" + request.id).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedAdditionalServiceKilometricPrice: (state) => {
      return state.selectedAdditionalServiceKilometricPrice;
    },
  },
};
